import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { primary, white } from '@styles/Colors';

const Button = styled.span<{ backgroundColor?: string }>`
  display: flex;
  min-width: 76px;
  padding: 13px 24px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  height: 48px;
  cursor: pointer;

  border-radius: 8px;
  background: ${(props) => props.backgroundColor || primary.blue};
`;

type Props = {
  readonly backgroundColor?: string;
  readonly children: React.ReactNode;
  readonly onClick?: () => void;
};

// TODO : 기존 Button 컴포넌트 분석해서 사용하자
export default function PrimaryButton({ backgroundColor, children, onClick }: Props) {
  return (
    <Button backgroundColor={backgroundColor} onClick={onClick}>
      {typeof children === 'string' ? (
        <Typography variant={TypoVariant.SH3} color={white} style={{ marginBottom: 'auto' }}>
          {children}
        </Typography>
      ) : (
        children
      )}
    </Button>
  );
}
